import { doFormSubmissionActions, resetFormMessage, resetFormMessages } from '../helpers/forms';
import wpAjax from '../helpers/axios';

function initContactForm() {
	const form = document.querySelector('.js-contact-form');

	if (form) {
		form.addEventListener('submit', async (e) => {
			e.preventDefault();

			// Reset error/success messages
			resetFormMessages(form);

			// Collect data from form
			const formData = new FormData(form);

			// Get the email to send the submission to
			const toEmail = document
				.querySelector('input[name="reasons"]:checked')
				.getAttribute('data-to-email');
			formData.append('to_email', toEmail);

			// Set function to run on backend
			formData.append('action', 'ajax_submit_contact_form');

			// Debug the form values
			// for (const pair of formData.entries()) {
			// 	console.log(`${pair[0]} = ${pair[1]}`);
			// }

			// Send to backend with a fake delay to make it less jarring for user
			form.classList.add('is-faded');
			const { data } = await wpAjax.post('', formData);
			setTimeout(() => {
				console.log(data);
				doFormSubmissionActions(form, data.status);
				form.classList.remove('is-faded');
			}, 1000);
		});
	}
}

initContactForm();
